import { defineMessages } from 'react-intl';

export default defineMessages({
    Actions: {
        id: 'quoteandbind.pup.views.pup-watercraft-operators-exposures.Actions',
        defaultMessage: 'Actions'
    },
    ActionsMobile: {
        id: 'quoteandbind.pup.views.pup-watercraft-operators-exposures.Actions Mobile',
        defaultMessage: 'Actions'
    },
    AddWatercraftOperator: {
        id: 'quoteandbind.pup.views.pup-watercraft-operators-exposures.Add Watercraft Operator',
        defaultMessage: 'Add'
    },
    AddNewWatercraftOperator: {
        id: 'common.controllers.MLPUPWatercraftOperatorsTableDirectiveCtrl.Add Watercraft Operator Not Listed',
        defaultMessage: 'Add Watercraft Operator Not Listed'
    },
    WatercraftOperatorHeader: {
        id: 'quoteandbind.pup.views.pup-watercraft-exposures.Watercraft operators',
        defaultMessage: 'Watercraft operators'
    },
    WatercraftOperatorParagraph: {
        id: 'common.views.ml-pup-watercraft-operators-table.No Information Exists',
        defaultMessage: 'No Information Exists'
    },
    AddWatercraftOperatorModalTitle: {
        id: 'common.views.ml-pup-watercraft-operators-table.Add a watercraft operator',
        defaultMessage: 'Add a watercraft operator'
    },
    EditWatercraftOperatorModalTitle: {
        id: 'common.views.ml-pup-watercraft-operators-table.Edit a watercraft operator',
        defaultMessage: 'Edit a watercraft operator'
    },
    MissingWatercraftOperators: {
        id: 'common.directives.MLPUPWatercraftOperatorsTableDirectiveCtrl.You must enter a watercraft operator(s) to continue',
        defaultMessage: 'You must enter a watercraft operator(s) to continue'
    },
    DateOfBirth: {
        id: 'quoteandbind.pup.views.pup-watercraft-operators-exposures.Date of Birth',
        defaultMessage: 'Date of Birth'
    },
    DateOfBirthMobile: {
        id: 'quoteandbind.pup.views.pup-watercraft-operators-operators-exposures.Date of Birth Mobile',
        defaultMessage: 'Date of Birth'
    },
    NAME: {
        id: 'quoteandbind.pup.views.pup-watercraft-operators-exposures.NAME',
        defaultMessage: 'NAME'
    },
    NAMEMobile: {
        id: 'quoteandbind.pup.views.pup-watercraft-operators-exposures.NAME Mobile',
        defaultMessage: 'NAME:'
    },
    GENDER: {
        id: 'quoteandbind.pup.views.pup-watercraft-operators-exposures.GENDER',
        defaultMessage: 'GENDER'
    },
    GENDERMobile: {
        id: 'quoteandbind.pup.views.pup-watercraft-operators-exposures.GENDER Mobile',
        defaultMessage: 'GENDER:'
    },
    RelationshipToInsured: {
        id: 'quoteandbind.pup.views.pup-watercraft-operators-exposures.Relationship to Insured',
        defaultMessage: 'Relationship to Insured'
    },
    RelationshipToInsuredMobile: {
        id: 'quoteandbind.pup.views.pup-watercraft-operators-exposures.Relationship to Insured Mobile',
        defaultMessage: 'Relationship to Insured:'
    },
    itemHasBeenAdded: {
        id: 'quoteandbind.pup.views.pup-watercraft-operators-exposures.itemHasBeenAdded',
        defaultMessage: '<strong>{displayName}</strong> has been added.'
    },
    itemHasBeenRemoved: {
        id: 'quoteandbind.pup.views.pup-watercraft-operators-exposures.itemHasBeenRemoved',
        defaultMessage: '<strong>{displayName}</strong> has been removed. <a>Undo</a>'
    },
});
